
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    NEQM: "NEQM",
    OPEQM: "OPEQM",
    PMISS: "PMISS",
    FMISS: "FMISS",
    NMISS: "NMISS",
    TA: "TA"
};
